module.exports = __webpack_public_path__ + "images/starnet.682e28ccd12c1153cab6d491a2428aa5.svg";